import React from 'react';
import type { RenderManifestQueueItem } from '../../../types/kryspaceRenderManifest';
import {
  CROSS_DOMAIN_MODE_LABELS,
  CROSS_DOMAIN_MODES,
  type CrossDomainMode,
} from './crossDomainAttention';
import styles from '../ControlBridge.module.css';

export interface CrossDomainAttentionStripProps {
  capacityHeadline: string;
  profileComplete: boolean;
  activeMode: CrossDomainMode;
  previewItems: RenderManifestQueueItem[];
  onModeChange: (mode: CrossDomainMode) => void;
  onViewAllExoPanel: () => void;
  onOpenRow?: (item: RenderManifestQueueItem) => void;
}

export const CrossDomainAttentionStrip: React.FC<CrossDomainAttentionStripProps> = ({
  capacityHeadline,
  profileComplete,
  activeMode,
  previewItems,
  onModeChange,
  onViewAllExoPanel,
  onOpenRow,
}) => {
  return (
    <section
      className={styles.crossDomainStrip}
      aria-label="Cross-domain attention"
      data-testid="cross-domain-attention-strip"
    >
      <div className={styles.crossDomainHeadlineRow}>
        <p className={styles.crossDomainHeadline}>
          {capacityHeadline || 'Review cross-domain attention'}
        </p>
        {!profileComplete ? (
          <span className={styles.crossDomainProfileBanner}>
            Complete profile for smarter routing
          </span>
        ) : null}
      </div>

      <div className={styles.crossDomainModeRow} role="group" aria-label="Mode query">
        {CROSS_DOMAIN_MODES.map((mode) => (
          <button
            key={mode}
            type="button"
            className={`${styles.crossDomainModeChip} ${
              activeMode === mode ? styles.crossDomainModeChipActive : ''
            }`}
            aria-pressed={activeMode === mode}
            onClick={() => onModeChange(mode)}
          >
            {CROSS_DOMAIN_MODE_LABELS[mode]}
          </button>
        ))}
      </div>

      {previewItems.length > 0 ? (
        <ul className={styles.crossDomainPreviewList}>
          {previewItems.map((item) => (
            <li key={`${item.workspaceSlug ?? ''}:${item.itemId}`}>
              <button
                type="button"
                className={styles.crossDomainPreviewRow}
                onClick={() => onOpenRow?.(item)}
              >
                <span className={styles.crossDomainPreviewTitle}>{item.title}</span>
                <span className={styles.crossDomainPreviewMeta}>
                  {item.workspaceLabel ?? item.workspaceSlug ?? 'workspace'}
                  {item.priority ? ` · ${item.priority}` : ''}
                </span>
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.crossDomainEmpty}>No items match this mode right now.</p>
      )}

      <button type="button" className={styles.crossDomainExoCta} onClick={onViewAllExoPanel}>
        View all in ExoPanel
      </button>
    </section>
  );
};
